import { FETCH_TIMESLOTS, UPDATE_TIMESLOT_BLOCKED } from "../constants/timeslots";

export function fetchTimeslots(officeId: number) {
  return {
    type: FETCH_TIMESLOTS,
    api: true,
    payload: {
      method: "GET",
      url: `/offices/${officeId}/timeslots`,
    },
    data: { officeId },
  };
}

export function setTimeslotBlocked(timeslotId: number, blocked: boolean, officeId: number | string) {
  return {
    type: UPDATE_TIMESLOT_BLOCKED,
    api: true,
    payload: {
      method: "PATCH",
      url: `/timeslots/${timeslotId}`,
      data: { blocked: blocked },
    },
    data: { timeslotId, officeId },
  };
}
